module.exports = global["rpDiffusion"] = require("-!/var/www/html/node_modules/rp-diffusion-connector/lib/index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/index.js
// module id = 70
// module chunks = 1